import { getPricing } from 'features/customer/store/selectors';
import { PricingPlan } from 'features/pricing/types';
import { useAppSelector } from 'store/hooks';

export const useIsOnSalesAssistedPlan = () => {
  const currentPricingPlan = useAppSelector(getPricing);

  // Rules defined in the task:
  // https://app.clickup.com/t/861n6my70?comment=90150122462872&threadedComment=90150123493166
  return (
    // This is a bit misleading ... this just says it's 0 cost
    currentPricingPlan.isFree &&
    currentPricingPlan.type !== PricingPlan.free &&
    !currentPricingPlan.isAllowedForRegistration
  );
};
